export const environment = {
  production: true,
  localapi: false,
  hmr: false,
  apiGatewayConfig: {
    apiGatewayUrl: 'https://api-gateway.drcedirect.com/',
    apiGatewayCloudUrl: 'https://api-gateway-cloud.drcedirect.com',
    deployment: 'production',
    enableCache: false,
  },
  portalUrl: 'https://www.drcedirect.com/all/eca-portal-v2-ui/#/login',
  localScanningApiUrl: `https://eca-local-scanning-service-prod.lrc.drcedirect.com/live`,
  dynamsoftResourcesPath: `https://api-gateway-cloud.drcedirect.com/eca-local-scanning-web-ui/all-production-v0/Resources`,
  ecaConfigService: 'https://api-caching.drcedirect.com/eca-setup-configuration-service/all-production-v0/v0/'
};
